import type { ExerciseActivity } from "@tandemdiabetes/sugarmate-api-react-client"
import { ExerciseIntensity } from "@tandemdiabetes/sugarmate-api-react-client"
import {
  FieldSet,
  Legend,
  SelectionButton,
  SelectionButtons,
} from "@tandemdiabetes/sugarmate-react-components"
import { useCallback } from "react"
import type { ChangeEventHandler } from "react"

import { usePolyglot } from "src/contexts"
import styles from "src/styles/entryModal.module.scss"

const polyglotPrefix = "components.entry_modal.exercise.intensity."

const intensityOptions: ExerciseIntensity[] = [
  ExerciseIntensity.Low,
  ExerciseIntensity.Medium,
  ExerciseIntensity.High,
]

interface Props {
  activity?: Partial<ExerciseActivity>;
  updateActivity: (a: Partial<ExerciseActivity>) => void;
}

export function ExerciseIntensityRadioButton(props: Props) {
  const {
    activity,
    updateActivity,
  } = props

  const polyglot = usePolyglot()

  const onExerciseIntensityChange: ChangeEventHandler<HTMLInputElement> = useCallback(
    (e) => {
      const newValue = e.target.value as ExerciseIntensity
      updateActivity({ intensity: newValue })
    },
    [updateActivity],
  )

  return (
    <FieldSet>
      <Legend
        className={styles.legend}
        sizePreset="small"
      >
        {polyglot.t(`${polyglotPrefix}legend`)}
      </Legend>
      <SelectionButtons id="exercise-intensity-select-buttons">
        {intensityOptions.map((exerciseIntensity) => (
          <SelectionButton
            key={exerciseIntensity}
            htmlFor={exerciseIntensity}
            value={exerciseIntensity}
            onChange={onExerciseIntensityChange}
            name="exercise_intensity"
            checked={activity?.intensity === exerciseIntensity}
            id={`exercise-intensity-select-button-${exerciseIntensity}`}
          >
            {polyglot.t(`${polyglotPrefix}${exerciseIntensity}`)}
          </SelectionButton>
        ))}
      </SelectionButtons>
    </FieldSet>
  )
}
